import { render, staticRenderFns } from "./lawofffastlaw.vue?vue&type=template&id=3136ea30&scoped=true&"
import script from "./lawofffastlaw.vue?vue&type=script&lang=js&"
export * from "./lawofffastlaw.vue?vue&type=script&lang=js&"
import style0 from "./lawofffastlaw.vue?vue&type=style&index=0&id=3136ea30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3136ea30",
  null
  
)

export default component.exports